export default (value) => {
  if (value === null || value === undefined || value === '') {
    return true;
  }

  const passNumber = new RegExp('^[1-9][0-9]*$').test(value);
  return value == -1 || passNumber;
};
